import { z } from 'zod';

/**
 * Per-customer rules on what may carry their cargo (gitaumoses4/chukua#48). A kind is one entry here plus one evaluator in the API
 * (`customer-restriction.policy.ts`); a customer's restrictions are rows, never a branch on the customer. Minimum insurance cover is a
 * planned kind, but compliance documents hold no cover amount yet.
 */
export const CUSTOMER_RESTRICTION_KINDS = ['max_truck_age'] as const;
export type CustomerRestrictionKind = (typeof CUSTOMER_RESTRICTION_KINDS)[number];

export const maxTruckAgeParamsSchema = z.object({ years: z.number().int().min(1).max(60) });

/** An advisory restriction warns instead of blocking. */
export const customerRestrictionInputSchema = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('max_truck_age'), params: maxTruckAgeParamsSchema, isAdvisory: z.boolean().default(false) }),
]);
export type CustomerRestrictionInput = z.infer<typeof customerRestrictionInputSchema>;

export interface CustomerRestrictionView {
  id: string;
  customerId: string;
  kind: CustomerRestrictionKind;
  params: { years: number };
  isAdvisory: boolean;
  createdAt: string;
  updatedAt: string;
}

export const CUSTOMER_RESTRICTION_LABELS: Record<CustomerRestrictionKind, string> = {
  max_truck_age: 'Maximum truck age (years)',
};
